/**
 * 稳定哈希抖动：同一 key 始终得到相同偏移，不同 key 分散过期时刻，避免集体失效洪峰。
 */

export function hashStableKey(input) {
  const s = String(input ?? '');
  let hash = 2166136261;
  for (let i = 0; i < s.length; i += 1) {
    hash ^= s.charCodeAt(i);
    hash = Math.imul(hash, 16777619);
  }
  return hash >>> 0;
}

export function jitterMsForStableKey(key, maxJitterMs) {
  const max = Math.max(0, Math.floor(Number(maxJitterMs) || 0));
  if (max <= 0) return 0;
  return hashStableKey(key) % max;
}

export function jitterSecondsForStableKey(key, maxJitterSeconds) {
  const max = Math.max(0, Math.floor(Number(maxJitterSeconds) || 0));
  if (max <= 0) return 0;
  return hashStableKey(key) % max;
}

/** 在 baseMs 时长上叠加 ±spread/2 的稳定抖动 */
export function ttlMsWithStableJitter(baseMs, key, spreadMs) {
  const base = Math.max(0, Number(baseMs) || 0);
  const spread = Math.max(0, Number(spreadMs) || 0);
  if (spread <= 0) return base;
  const half = Math.floor(spread / 2);
  return base - half + jitterMsForStableKey(key, spread);
}

export function expiresAtWithStableJitter(nowMs, baseTtlMs, key, spreadMs) {
  return nowMs + ttlMsWithStableJitter(baseTtlMs, key, spreadMs);
}

/** sign-batch / 刷新前的额外错峰延迟（毫秒） */
export function staggerDelayMsForKey(key, maxDelayMs = 120_000) {
  return jitterMsForStableKey(key, maxDelayMs);
}
